var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClothOn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.b{clip-path:url(#a);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 22.722,
    height: 23.69
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-330 15295)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 35,
    height: 35,
    transform: "translate(330 -15295)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(336 -15288.83)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.767,23.685a15.31,15.31,0,0,1-5.7-.946c-.39-.154-.758-.365-1.136-.551-.194-.1-.235-.22-.172-.445C4.276,19.886,4.8,18.03,5.28,16.161a14.866,14.866,0,0,0,.485-4.051A8.344,8.344,0,0,0,5.256,9.7C5.124,9.3,5,8.9,4.874,8.5c-.1-.325-.2-.406-.522-.293a7.508,7.508,0,0,0-.994.458c-.72.374-.711.371-1.332-.165A6.716,6.716,0,0,1,.483,6.317a7.2,7.2,0,0,0-.425-.737.219.219,0,0,1,.015-.31,16.275,16.275,0,0,1,3.1-2.991A13.526,13.526,0,0,1,5.524,1.107C6.274.745,7.037.41,7.791.055A.492.492,0,0,1,8.33.113,5.208,5.208,0,0,0,10.295,1,4.93,4.93,0,0,0,13.672.46c.235-.123.452-.283.694-.389a.553.553,0,0,1,.4-.017c1.2.549,2.395,1.1,3.583,1.678A12.232,12.232,0,0,1,21.1,3.641a21.936,21.936,0,0,1,1.557,1.625.318.318,0,0,1,.049.288c-.363.667-.726,1.335-1.122,1.982a4.478,4.478,0,0,1-1.316,1.312.448.448,0,0,1-.367.044c-.345-.145-.675-.327-1.01-.5-.057-.029-.112-.063-.17-.091-.558-.271-.728-.206-.872.383-.2.834-.431,1.667-.564,2.513a13.269,13.269,0,0,0-.06,4.052c.159,1.056.278,2.123.514,3.163.26,1.147.626,2.271.964,3.4.057.19-.019.242-.153.308a14.132,14.132,0,0,1-3.268,1.113,19.313,19.313,0,0,1-4.516.448",
    transform: "translate(0 0)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClothOn);
export default __webpack_public_path__ + "static/media/clothON.cbb2a962a42e55f294fef34d06202d64.svg";
export { ForwardRef as ReactComponent };